import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {
  Button, Form, Modal, Row, Spinner,
} from 'react-bootstrap';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import useAuth from '../../hooks/useAuth';
import { pageButtonRenderer, customTotal } from '../../common/constants';
import MyModalComponent from '../../components/myModalComponent';
import UserCard from '../../components/userCard';
import axiosCore from '../../common/axiosCore';
import { logout } from '../../services/MockAuthService';
import IdleTimer from '../../services/idleTimer';
import AlertTimeout from '../../components/alertTimeout';

function Claim() {
  const title = 'Benefit';
  const { getSession } = useAuth();
  const [BenefitId, setBenefitId] = useState();
  const { getEligibleBenefit } = useAuth();
  const navigate = useNavigate();
  const user = getSession();
  const benefit = getEligibleBenefit();
  const [show, setShow] = useState(false);
  const [showClaim, setShowClaim] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalBody, setModalBody] = useState('');
  const [data, setData] = useState([]);
  const [OffId, setOffId] = useState();
  const [bft, setBft] = useState([]);
  const [offices, setOffices] = useState([]);
  const [benefitsList, setBenefitsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isWaiting, setIsWaiting] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const { getMemberProfile } = useAuth();
  const member = getMemberProfile();

  const [isTimeout, setIsTimeout] = useState(false);
  const handleLogout = async () => {
    await logout();
    navigate('/');
    setIsTimeout(true);
  };
  useEffect(() => {
    const timer = new IdleTimer({
      // expire after 10 seconds
      timeout: 180,
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        // do something if expired on load
        handleLogout().then();
      },
    });

    return () => {
      timer.cleanUp();
    };
  }, []);

  const claimsList = () => {
    setTimeout(() => {
      axiosCore.post('/member-module/claim-status/index', {
        MemberId: member.MemberId,
      }).then((result) => {
        if (result.data.status === 1) {
          setIsWaiting(false);
          setBenefitsList(result.data.data);
        }
        if (result.data.status === 0) {
          setIsWaiting(false);
          setBenefitsList(result.data.data);
        }
      }).catch(() => {
        setIsError(true);
      });
    }, 2000);
  };

  useEffect(() => {
    const benefitLoad = () => {
      const eb = benefit.map((i) => ({
        label: i.DESCRIPTION,
        value: i.ID,
      }));
      console.log(eb);
      setBft(eb);
    };
    const loadOffice = () => {
      axiosCore.get('/nssf-office/index').then((response) => {
        const json = response.data.feedback;
        const office = json.map((i) => ({
          label: i.OFFICE_NAME,
          value: i.OFFICE_ID,
        }));
        setOffices(office);
      });
    };
    benefitLoad();
    claimsList();
    loadOffice();
    setIsValid(!!OffId);
  }, [OffId]);

  const handleClose = () => {
    setShow(false);
    setShowClaim(false);
  };

  const handleShow = () => setShow(true);

  const handleLodgeClaim = () => {
    if (OffId && BenefitId) {
      setIsLoading(true);
      setTimeout(() => {
        axiosCore.post('/member-module/benefit/save-appointment', {
          MemberId: member.MemberId,
          OfficeId: OffId,
          BenefitType: BenefitId,
        }).then((result) => {
          if (result.data.status === 1) {
            setIsWaiting(true);
            claimsList();
            setIsLoading(false);
            setShow(false);
            setIsAlert(true);
          }
          if (result.data.status === 2) {
            setIsWaiting(true);
            claimsList();
            setIsLoading(false);
            setShow(false);
            setIsPending(true);
          }
        }).catch(() => {
          setIsWaiting(true);
          claimsList();
          setIsLoading(false);
          setShow(false);
          setIsError(true);
        });
      }, 2000);
    }
  };

  const getActionFormat = (cell, row) => (
      <div>
        <Button className="btn btn-green btn-sm" onClick={() => {
          setData(row);
          setModalTitle('Claim Status');
          setShowClaim(true);
        }} >
          View
        </Button>
      </div>);

  const columns = [{
    dataField: 'CLAIM_ID',
    text: 'Claim ID',
    headerStyle: (column, colIndex) => ({
      width: '100px',
    }),
  },
  {
    dataField: 'DESCRIPTION',
    text: 'Benefit',
  },
  {
    dataField: 'OFFICE_NAME',
    text: 'Office',
  },
  {
    dataField: 'CLAIM_STATUS',
    text: 'Status',
  },
  {
    dataField: 'actions',
    text: 'Actions',
    isDummyField: true,
    formatter: getActionFormat,
    headerStyle: (column, colIndex) => ({
      width: '80px',
    }),
  }];

  const benefitLodged = () => {
    if (benefitsList.length > 0) {
      return <span>
        <div className="table-responsive">
        <BootstrapTable
          bootstrap4
          keyField='ID'
          data={ benefitsList }
          columns={ columns }
          pagination={ paginationFactory(options) }
          striped
          hover
          condensed
        />
      </div>
      </span>;
    }
    return <span>
      {!isWaiting && <p className="text-center">No claims</p>}
    </span>;
  };

  const handleSelectOffice = (e) => {
    setOffId(e.value);
  };

  const handleSelectBenefit = (e) => {
    setBenefitId(e.value);
  };

  const options = {
    pageButtonRenderer,
    paginationSize: 19,
    pageStartIndex: 0,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: 'First',
    prePageText: 'Back',
    nextPageText: 'Next',
    lastPageText: 'Last',
    nextPageTitle: 'First page',
    prePageTitle: 'Pre page',
    firstPageTitle: 'Next page',
    lastPageTitle: 'Last page',
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [{
      text: '20', value: 20,
    }, {
      text: '40', value: 40,
    }, {
      text: 'All', value: benefitsList.length,
    }], // A numeric array is also available. the purpose of above example is custom the text
  };

  const onConfirm = () => {
    setIsAlert(false);
    setIsPending(false);
    setIsError(false);
    setIsWaiting(false);
  };

  const onCancel = () => {
    const timer = new IdleTimer({
      // expire after 10 seconds
      timeout: 180,
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        // do something if expired on load
        handleLogout().then();
        setIsTimeout(true);
      },
    });
    setIsTimeout(false);
    return () => {
      timer.cleanUp();
    };
  };

  if (user) {
    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <main className="container">
          <Breadcrumb>
            <Breadcrumb.Item><Link to="/console/dashboard">Dashboard</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>{title}</Breadcrumb.Item>
          </Breadcrumb>
          <div className="row">
            <div className="col">
              <h1 className="page-title">{title}</h1>
            </div>
            <div className="col">
              {/* <Link type="button" className="btn btn-claim mb-3" to="/console/lodge-claim"> */}
              {/*  <FaPlus/> Lodge Claim */}
              {/* </Link> */}
                {/* <button type="button" className="btn btn-claim mb-3" onClick={handleShow}><FaPlus/> Lodge Claim </button> */}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 rounded">
              <UserCard/>
            </div>
            <div className="col-lg-8 rounded">
              <div className="card">
                <h6 className="card-header d-flex justify-content-between align-items-center">
                  Claims
                </h6>
                <div className="card-body m-0">
                  {isWaiting && <p className="text-center">
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      hidden={!isWaiting}/> Please wait...</p>}
                  <div className="table-responsive">
                    {benefitLodged()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        {isAlert
        && <SweetAlert
          success
          title="Success Data!"
          onConfirm={onConfirm}
          timeout={2000}
        >
          This success message will automatically close after 2 seconds
        </SweetAlert>
        }
        {isError
        && <SweetAlert
          warning
          title="Oops, an error occurred."
          onConfirm={onConfirm}
          timeout={10000}
        >
          Check your connection and try again
        </SweetAlert>}
        {isPending
        && <SweetAlert
          warning
          title="Oops, you have a pending claim."
          onConfirm={onConfirm}
          timeout={50000}
        >
          Please wait for your previous claim to be processed
        </SweetAlert>}
        <MyModalComponent
          show={showClaim}
          title={modalTitle}
          body={modalBody}
          data={data}
          onClick={handleClose}
          onHide={handleClose}
        />
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Lodge Claim</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form >
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <Form.Label>
                  <strong>FULL NAME:</strong> {user.FULL_NAME}
                </Form.Label>
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <Form.Label>
                  <strong>MEMBER ID:</strong> {user.MEMBER_ID}
                </Form.Label>
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <Form.Label>
                  <strong>DATE OF BIRTH:</strong> {user.DATE_OF_BIRTH}
                </Form.Label>
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <Form.Label><strong>BENEFIT TYPE</strong></Form.Label>
                <Select
                  onChange={handleSelectBenefit.bind(this)}
                  placeholder={'type something ...'}
                  options={bft}
                />
              </Form.Group>
              <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                <Form.Label><strong>NSSF OFFICE</strong></Form.Label>
                <Select
                  onChange={handleSelectOffice.bind(this)}
                  placeholder={'type something ...'}
                  options={offices}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button className='btn btn-light' onClick={handleClose}>
              Close
            </Button>
            <Button className='btn btn-green' onClick={handleLodgeClaim}>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                hidden={!isLoading}/>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
        {isTimeout
        && <AlertTimeout onConfirm={handleLogout} onCancel={onCancel}/>
        }
      </>
    );
  }
  navigate('/login');
}
export default Claim;
